import { DropdownOption } from 'models/Dropdown';
import { Enterprise, EnterpriseMember } from 'models/Enterprises';
import { createContext } from 'react';
import utils from 'utils';
import { Option } from 'models/Global';
import { DEFAULT_LIMIT } from 'data/global';

type EnterpriseMembersContextProps = {
  enterpriseId: string;
  enterprise: Partial<Enterprise>;
  members: EnterpriseMember[];
  isLoading: boolean;
  totalPages: number;
  totalItems: number;
  hasNotInvitedMembers: boolean;
  isEmpty: boolean;
  isLoadingAddMember: boolean;
  isAllSelected: boolean;
  isRemoveDisabled: boolean;
  selected: EnterpriseMember[];
  units: Option[];
  brokers: Option[];
  memberSeniorities: Option[];
  locations: Option[];
  limit: string;
  refetch: () => void;
  handleAddPeople: () => void;
  onSelectAll: () => void;
  getDropdownOptions: (members?: EnterpriseMember[]) => DropdownOption[];
  updateSelected: (member: EnterpriseMember) => void;
  handleEditMember: (member: EnterpriseMember) => void;
  checkIfMemberIsSelected: (member: EnterpriseMember) => boolean;
  handleSendInvitesToNonInvited: () => void;
  handleSendInvites: (members: EnterpriseMember[]) => void;
  handleSendReminders: (members: EnterpriseMember[]) => void;
  deleteMembers: (members: EnterpriseMember[]) => Promise<void>;
  updateLimit: (limit: string) => void;
};

export default createContext<Partial<EnterpriseMembersContextProps>>({
  enterpriseId: '',
  enterprise: null,
  members: [],
  isLoading: true,
  isEmpty: false,
  totalPages: 1,
  totalItems: 0,
  hasNotInvitedMembers: false,
  isLoadingAddMember: false,
  isAllSelected: false,
  isRemoveDisabled: false,
  selected: [],
  units: [],
  brokers: [],
  memberSeniorities: [],
  locations: [],
  limit: DEFAULT_LIMIT,
  getDropdownOptions: utils.noop,
  updateSelected: utils.noop,
  onSelectAll: utils.noop,
  handleSendInvites: utils.noop,
  refetch: utils.noop,
  handleAddPeople: utils.noop,
  handleEditMember: utils.noop,
  checkIfMemberIsSelected: utils.noop,
  handleSendInvitesToNonInvited: utils.noop,
  handleSendReminders: utils.noop,
  deleteMembers: utils.noop,
  updateLimit: utils.noop,
});
